export default __webpack_public_path__ + "static/media/keyboard.c1e3c380.png";